import { render, staticRenderFns } from "./FinanceInvoices.vue?vue&type=template&id=bf572118&"
import script from "./FinanceInvoices.vue?vue&type=script&lang=ts&"
export * from "./FinanceInvoices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports